import store from '@/store'

/**
 * 动态权限指令
 * 使用方法：
 * v-dynamic-permission="'oa:user:add'"
 * v-dynamic-permission="['oa:user:add', 'oa:user:edit']"
 * v-dynamic-permission.any="['oa:user:add', 'oa:user:edit']" // 满足任一权限即可
 * v-dynamic-permission.all="['oa:user:add', 'oa:user:edit']" // 必须满足所有权限
 */

function checkPermission(el, binding) {
  const { value, modifiers } = binding
  const userPermissions = store.getters['dynamicRoute/permissions'] || []

  if (value) {
    let hasPermission = false
    
    // 如果没有权限数据，默认显示（避免权限数据未加载时隐藏元素）
    if (userPermissions.length === 0) {
      console.warn('权限数据未加载，默认显示元素')
      return
    }
    
    if (Array.isArray(value)) {
      if (modifiers.all) {
        // 必须拥有所有权限
        hasPermission = value.every(permission => userPermissions.includes(permission))
      } else {
        // 默认为any模式，拥有任一权限即可
        hasPermission = value.some(permission => userPermissions.includes(permission))
      }
    } else {
      // 单个权限
      hasPermission = userPermissions.includes(value)
    }

    if (!hasPermission) {
      console.log(`权限验证失败，隐藏元素: ${value}`)
      el.style.display = 'none'
      // 使用display:none而不是移除元素，避免Vue的响应式问题
      // el.parentNode && el.parentNode.removeChild(el)
    } else {
      el.style.display = ''
    }
  } else {
    console.warn('v-dynamic-permission指令需要提供权限值')
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}